export interface Service {
  id: string;
  name: string;
  description: string;
  link: string;
}

export const services: Record<string, Service> = {
  job: {
    id: "job",
    name: "WorkBC",
    description: "Employment and career services in British Columbia",
    link: "https://www.workbc.ca",
  },
  english: {
    id: "english",
    name: "MOSAIC",
    description: "Language training and community support",
    link: "https://mosaicbc.org",
  },
  family: {
    id: "family",
    name: "ISSofBC",
    description: "Settlement and integration services for newcomers",
    link: "https://issbc.org",
  },
  community: {
    id: "community",
    name: "SUCCESS",
    description: "Employment, business, and settlement services",
    link: "https://successbc.ca",
  },
  credentials: {
    id: "credentials",
    name: "Credential Recognition Service",
    description: "Support for recognition of international credentials",
    link: "#",
  },
};
